import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class EncodeDecodeService {
  /**
   * Stringifies an object and @returns encoded string.
   * @param value
   */
  encodeJson(value: any): string {
    const jsonString: string = JSON.stringify(value);
    return this.encode(jsonString);
  }

  /**
   * Stringifies an object and @returns decoded string.
   * @param value
   */
  decodeJson(value: any): string {
    const jsonString: string = JSON.stringify(value);
    return this.decode(jsonString);
  }

  /**
   * @returns encoded string.
   * @param value
   */
  encodeString(value: string): string {
    return this.encode(value);
  }

  /**
   * @returns decoded
   */
  decodeString(value: string): string {
    return this.decode(value);
  }

  /**
   * Emails contain specific characters generated by the editor, so the decode needs to create
   * A new string in which certain characters have been escaped.
   * @param value
   */
  decodeEmail(value: string): string {
    try {
      // TODO: Find alternative for legacy emails that were built in quill.
      // eslint-disable-next-line deprecation/deprecation
      return decodeURIComponent(escape(value));
    } catch {
      return value;
    }
  }

  /**
   * Encode string that are in ISO format.
   * @param value
   */
  private encode(value: string): string {
    try {
      return encodeURIComponent(value);
    } catch {
      return "";
    }
  }

  /**
   * Decode string and remove any special characters that are in ISO format.
   */
  private decode(value: string): string {
    try {
      return decodeURIComponent(value);
    } catch {
      return "";
    }
  }
}
